import { render, staticRenderFns } from "./VisitNumInfo.vue?vue&type=template&id=55830e96&scoped=true"
import script from "./VisitNumInfo.vue?vue&type=script&lang=js"
export * from "./VisitNumInfo.vue?vue&type=script&lang=js"
import style0 from "./VisitNumInfo.vue?vue&type=style&index=0&id=55830e96&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55830e96",
  null
  
)

export default component.exports